// action - state management
import { LOGIN, LOGOUT, REGISTER, UPDATEPROFILE } from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {    
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    menu: null,
    company: null,
    role: null,
    accessToken: '',
};

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER: {
            const { user } = action.payload;
            return {
                ...state,
                user
            };
        }
        case UPDATEPROFILE: {
            const { user } = action.payload;
            return {
                ...state,
                user
            };
        }
        case LOGIN: {
            const { user, menu, company, role, accessToken } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                user,
                menu,
                company,
                role,
                accessToken,
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null,
                company: null,
                role: null,
                accessToken: ''
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
